import * as React from "react"
import { Link } from "gatsby"

function Button(props) {
    return(
        <Link to={`${props.link}`} className="bg-gray-400 bg-opacity-75 shadow w-72 h-20 flex justify-center items-center rounded-full font-dokdo text-white text-4xl text-center px-4 py-3 transition duration-300 ease-in-out hover:bg-opacity-100 transform hover:scale-105">
            {props.children}
        </Link>
    )
}

export default Button